// extracted by mini-css-extract-plugin
export default {"modal":"Eja-z","header":"Fja-z","fields":"Gja-z","error":"Hja-z","disabled":"Ija-z","reminderMsg":"Jja-z","errorMsg":"Kja-z","footer":"Lja-z"};